module.exports = __webpack_public_path__ + "static/10-3dea9faeab52fe6f3220288e6b5c46c3.jpg";